import "./userList.css";
import {makeStyles} from "@material-ui/core/styles";
import {DataGrid} from "@mui/x-data-grid";
import React, {useEffect, useState} from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Typography from "@mui/material/Typography";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import {
    Autocomplete,
    FormControl,
    FormHelperText,
    MenuItem,
    Select,
    TextareaAutosize,
    useMediaQuery,
} from "@mui/material";
import {InputLabel, TextField} from "@material-ui/core";
import {Add, DeleteOutline} from "@mui/icons-material";
// import * as Yup from "yup";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {useNavigate} from "react-router-dom";
import {ApiDetails, KEY} from "../../Constants";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import CryptoJS from "crypto-js";
import Switch from "@mui/material/Switch";
import { handle401Unauthorized, handle403Forbidden } from '../../utils/authErrorHandler';


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>,
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

//create your forceUpdate hook WHICH DID NOT WORK

const useStyles = makeStyles({
    root: {
        "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
            outline: "none",
        },
        "& .MuiDataGrid-columnHeaders": {
            fontSize: 16,
            color: "darkblue",
            backgroundColor: "rgb(245,245,245)",
        },
    },
});

export default function OldTenantList(props) {
    const matches = useMediaQuery("(max-width:700px)");
    const label = {inputProps: {"aria-label": "Switch demo"}};

    let myMapDetailsDecrypted = CryptoJS.AES.decrypt(
        localStorage.getItem("myMap"),
        KEY
    );
    let portfolioDetailsDecrypted = CryptoJS.AES.decrypt(
        localStorage.portfolioDetails,
        KEY
    );
    let originalText = myMapDetailsDecrypted.toString(CryptoJS.enc.Utf8);
    let originalText2 = portfolioDetailsDecrypted.toString(CryptoJS.enc.Utf8);
    //Navigator
    const navigate = useNavigate();

    //Loading Screen
    const [backDrop, setBackDrop] = useState(
        <Backdrop
            sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={true}
            onClick={null}
        >
            <CircularProgress color="inherit"/>
        </Backdrop>
    );

    let [tenants, updateTenants] = React.useState([]);
    const [searchResults, setSearchResults] = useState(tenants);
    let [properties, updateProperties] = React.useState([]);

    //Trying To Use UseEffect To Set Component Data
    useEffect(() => {
        props.refreshSideBar();
        //"proxy":"http://0.0.0.0:8080/pegasus/visionary",
        fetch(ApiDetails + "pegasus/visionary/tenant/get/vacated/tenants", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]  // Replace with your actual token variable
            },
            body: JSON.stringify({
                // landlord_email_address: JSON.parse(originalText)[5][1],
                landlord_id: JSON.parse(originalText)[0][1],
            }),
        })
            .then(async (response) => {
                let tenants = await response.json();

                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    //Get All Properties
                    fetch(ApiDetails + "pegasus/visionary/property/get/all/properties", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]  // Replace with your actual token variable
                        },
                        body: JSON.stringify({
                            landlord_id: JSON.parse(originalText)[0][1],
                        }),
                    })
                        .then(async (response) => {
                            let data = await response.json();

                             // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                                // console.log(typeof tenants[0].MINIMUM_STAY);
                                updateProperties(data);
                                updateTenants(tenants);
                                setSearchResults(tenants);
                                setBackDrop(<></>);
                                // setDetailsFetched(true);
                            } else {
                                props.snackBar({
                                    text: "Failed Fetching Details",
                                    type: "error",
                                });
                            }
                        })
                        .catch((err) => console.log(err));
                } else {
                    props.snackBar({text: "Failed Fetching Details", type: "error"});
                }
            })
            .catch((err) => console.log(err));
    }, []);

    //Modal states
    const [deleteModal, setOpen] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [arrearsModal, setArrearsModal] = useState(false);
    const [addTenantModal, setAddTenantModal] = useState(false);

    //Units State
    const [units, setUnits] = React.useState(null);
    const [selectedUnit, setSelectedUnit] = React.useState(null);

    const [isStudent, setIsStudent] = React.useState("NO");

    let [tenantInfo, setTenantInfo] = React.useState({
        tenant_id: "",
        name: "",
        last_name: "",
        unit: "",
        property_id: "",
    });
    const [propertyName, setPropertyName] = React.useState(null);

    const [addTenantPropertyName, setAddTenantPropertyName] = React.useState("");
    let [propertyID, setPropertyID] = React.useState(null);

    let initialValues = {
        id: "",
        first_name: "",
        description: "",
        amount: "",
    };
    const initialValues2 = {
        first_name: "",
        landlord_id: JSON.parse(originalText)[0][1],
        occupation_or_profession: "",
        last_name: "",
        phone_number: "",
        national_id: "",
        next_of_kin_relationship: "",
        next_of_kin_first_name: "",
        next_of_kin_last_name: "",
        next_of_kin_national_id: "",
        next_of_kin_contacts: "",
        institution_name: "",
        place_of_work: "",
        reason_for_relocating: "",
        previous_residence: "",
        email_address: "",
        rent: "",
    };

    //Tenant Photo
    const [tenantPhoto, setTenantPhoto] = useState(null);
    const [photo, setPhoto] = useState(null);

    //Tenant National ID
    const [photoOfNationalID, setPhotoOfNationalID] = useState(null);
    const [nationalID, setNationalID] = useState(null);

    //Tenant Contract
    const [copyOfContract, setCopyOfContract] = useState(null);
    const [contract, setContract] = useState(null);

    //Tenant Checklist
    const [inventoryChecklist, setInventoryChecklist] = useState(null);
    const [checklist, setChecklist] = useState(null);

    function handleFile1(e) {
        let filename = getFileName(e);
        if (checkImageFile(filename)) {
            setPhoto(filename);
            setTenantPhoto(e.target.files[0]);
        } else {
            props.snackBar({
                text: "Please Upload An Image File",
                type: "warning",
            });
        }
    }

    function handleFile2(e) {
        let filename = getFileName(e);
        if (checkImageFile(filename)) {
            setNationalID(filename);
            setPhotoOfNationalID(e.target.files[0]);
        } else {
            props.snackBar({
                text: "Please Upload An Image File",
                type: "warning",
            });
        }
    }

    function handleFile3(e) {
        let filename = getFileName(e);
        if (checkTextFile(filename)) {
            setContract(filename);
            setCopyOfContract(e.target.files[0]);
        } else {
            props.snackBar({
                text: "Please Upload A text,doc,docx or pdf File",
                type: "warning",
            });
        }
    }

    function handleFile4(e) {
        let filename = getFileName(e);
        if (checkTextFile(filename)) {
            setChecklist(filename);
            setInventoryChecklist(e.target.files[0]);
        } else {
            props.snackBar({
                text: "Please Upload A text,doc,docx or pdf File",
                type: "warning",
            });
        }
    }

    const getFileName = (e) => {
        let startIndex =
            e.target.value.indexOf("\\") >= 0
                ? e.target.value.lastIndexOf("\\")
                : e.target.value.lastIndexOf("/");
        let filename = e.target.value.substring(startIndex);
        if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
            filename = filename.substring(1);
        }
        return filename;
    };

    function getExtension(filename) {
        let parts = filename.split(".");
        return parts[parts.length - 1];
    }

    function checkImageFile(filename) {
        let ext = getExtension(filename);
        switch (ext.toLowerCase()) {
            case "jpg":
            case "png":
            case "pdf":
                //etc
                return true;
        }
        return false;
    }

    function checkTextFile(filename) {
        let ext = getExtension(filename);
        switch (ext.toLowerCase()) {
            case "txt":
            case "doc":
            case "docx":
            case "pdf":
                //etc
                return true;
        }
        return false;
    }

    const classes = useStyles();

    const handleClose = () => {
        setAddTenantModal(false);
        setArrearsModal(false);
        setOpen(false);
    };
    const handleDelete = () => {
        loadingTrue();
        let tenantPropertyMap = properties.filter(
            (property) =>
                new Map(Object.entries(property)).get("property_id") ===
                tenantInfo.property_id
        );

        let tenantPropertyName = new Map(Object.entries(tenantPropertyMap[0])).get(
            "property_name"
        );

        //Make API call to delete tenant
        fetch(ApiDetails + "pegasus/visionary/tenant/delete", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]  // Replace with your actual token variable
            },
            body: JSON.stringify({
                ...tenantInfo,
                property_name: tenantPropertyName,
                landlord_email_address: JSON.parse(originalText)[5][1],
            }),
        })
            .then(async (response) => {
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    getUserDetails2({
                        landlord_id: JSON.parse(originalText)[0][1],
                    });
                    props.snackBar({
                        text: "Tenant Deleted Successful",
                        type: "success",
                    });
                    handleClose();
                    window.location.href = "/tenantList";
                } else if (response.status === 500) {
                    props.snackBar({
                        text: "Something went wrong. Please try again later.",
                        type: "error",
                    });
                }
                loadingFalse();
            })
            .catch((err) => {
                console.log(err);
                loadingFalse();
                props.snackBar({
                    text: "Something Went Wrong. Try Again Later",
                    type: "error",
                });
            });
    };

    const searchUser = (e) => {
        if (propertyName === null) {
            setSearchResults(
                Array.from(tenants).filter((item) =>
                    (
                        item.first_name.toString().toLowerCase() +
                        item.last_name.toString().toLowerCase()
                    ).includes(e.target.value.toLowerCase())
                )
            );
        } else if (propertyName !== null) {
            setSearchResults(
                Array.from(tenants).filter((item) => {
                    if (
                        (
                            item.first_name.toString().toLowerCase() +
                            item.last_name.toString().toLowerCase()
                        )
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase()) &&
                        item.property.toLowerCase().includes(propertyName.toLowerCase())
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                })
            );
        }
    };
    const searchProperty = (e) => {
        if (e === null) {
            setPropertyName(null);
            setSearchResults(Array.from(tenants));
        } else {
            let propertySelected = new Map(JSON.parse(originalText2))
                .get("properties")
                .filter((property) => property.id === e);

            let selectedPropertyName = new Map(
                Object.entries(new Map(Object.entries(propertySelected)).get("0"))
            ).get("property_name");
            setPropertyName(selectedPropertyName);
            setSearchResults(
                Array.from(tenants).filter((tenant) => tenant.property_id === e)
            );
        }
    };
    const getUserDetails = (userDetails) => {
        //"proxy":"http://0.0.0.0:8080/pegasus/visionary",
        fetch(ApiDetails + "pegasus/visionary/tenant/get/all/tenants", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]  // Replace with your actual token variable
            },
            body: JSON.stringify({
                landlord_id: JSON.parse(originalText)[0][1],
            }),
        })
            .then(async (response) => {
                let tenants = await response.json();

                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    // console.log(data);
                    updateTenants(tenants);
                    setSearchResults(tenants);
                } else {
                    props.snackBar({text: "Failed Fetching Details", type: "error"});
                }
            })
            .catch((err) => console.log(err));
    };
    const getUserDetails2 = (userDetails) => {
        //"proxy":"http://0.0.0.0:8080/pegasus/visionary",
        fetch(ApiDetails + "pegasus/visionary/dashboard/get/details", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]  // Replace with your actual token variable
            },
            body: JSON.stringify(userDetails),
        })
            .then(async (response) => {
                let data = await response.json();

                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    const map1 = new Map(Object.entries(data));
                    //localStorage.setItem("userDetails",new Map(Object.entries(data)));
                    let portfolioDetails = CryptoJS.AES.encrypt(
                        JSON.stringify(Array.from(map1.entries())),
                        KEY
                    ).toString();
                    localStorage.portfolioDetails = portfolioDetails;
                } else {
                    props.snackBar({text: "Failed Fetching Details", type: "error"});
                }
            })
            .catch((err) => console.log(err));
    };
    const addArrears = (values) => {
        //Add arrear to database
        let body = {
            tenant_id: tenantInfo.id,
            description: values.description,
            amount: values.amount,
        };

        fetch(ApiDetails + "pegasus/visionary/tenant/add/arrears", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]  // Replace with your actual token variable
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    getUserDetails({
                        landlord_id: JSON.parse(originalText)[0][1],
                    });
                    handleClose();
                } else {
                    props.snackBar({
                        text: "Something Went Wrong. Try Again Later",
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                props.snackBar({
                    text: "Something Went Wrong. Call Customer Care For Assistance.",
                    type: "error",
                });
            });
    };
    const addTenant = (values) => {
        setLoading(true);
        values.is_student = isStudent;
        values.landlord_email_address = JSON.parse(originalText)[5][1];
        values.property_name = JSON.parse(originalText2)[1][1].filter(
            (item) => item.id === addTenantPropertyName
        )[0].property_name;
        values.property_id = addTenantPropertyName;
        values.house_number = selectedUnit;

        let formData = new FormData();
        //Add values to formData
        //formData.append("details", [detailsMap]);
        formData.append("body", JSON.stringify(values));
        formData.append("photo_of_national_id", photoOfNationalID);
        formData.append("copy_of_contract", copyOfContract);
        formData.append("inventory_checklist", inventoryChecklist);
        formData.append("tenant_photo", tenantPhoto);

        //"proxy":"http://0.0.0.0:8080/pegasus/visionary",
        fetch(ApiDetails + "pegasus/visionary/tenant/add/tenant", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]  // Replace with your actual token variable
            },
            body: formData,
        })
            .then(async (response) => {
                let data = await response.json();
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    getUserDetails({
                        landlord_id: JSON.parse(originalText)[0][1],
                    });
                    props.snackBar({
                        text: "Tenant Added Successful",
                        type: "success",
                    });
                    handleClose();
                } else if (response.status === 401) {
                    props.snackBar({
                        text: "Maximum concurrent logins reached",
                        type: "warning",
                    });
                } else if (response.status === 400) {
                    props.snackBar({
                        text: "Invalid Credentials Provided.",
                        type: "error",
                    });
                } else if (response.status === 500) {
                    if (data["Message"].includes("duplicate key")) {
                        props.snackBar({
                            text: "Phone Number Already Exists",
                            type: "error",
                        });
                        return;
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                props.snackBar({
                    text: "Something Went Wrong. Try Again Later",
                    type: "error",
                });
            });

        setLoading(false);
    };
    const getUnits = () => {
        //Make API call
        //"proxy":"http://0.0.0.0:8080/pegasus/visionary",
        fetch(ApiDetails + "pegasus/visionary/property/getUnits", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]  // Replace with your actual token variable
            },
            body: JSON.stringify({property_id: propertyID}),
        })
            .then(async (response) => {
                let data = await response.json();
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    setUnits(data);
                    props.snackBar({
                        text: "Property Units Retreived Successful",
                        type: "success",
                    });
                } else if (response.status === 401) {
                    props.snackBar({
                        text: "Maximum concurrent logins reached",
                        type: "warning",
                    });
                } else if (response.status === 400) {
                    props.snackBar({
                        text: "Invalid Credentials Provided.",
                        type: "error",
                    });
                } else if (response.status === 500) {
                    if (data["Message"].includes("duplicate key")) {
                        if (data["Message"].includes("owners_email_address_uindex")) {
                            props.snackBar({
                                text: "Email Address Already Exists",
                                type: "error",
                            });
                            return;
                        }
                    }
                    props.snackBar({
                        text: "Something went wrong. Please try again later.",
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                props.snackBar({
                    text: "Something Went Wrong. Try Again Later",
                    type: "error",
                });
            });
    };

    const [loading, setLoading] = React.useState(false);

    function loadingTrue() {
        setLoading(true);
    }

    function loadingFalse() {
        setLoading(false);
    }

    const columns = [
        {
            field: "user",
            headerName: "Name",
            minWidth: 150,
            flex: 1,
            // width: 150,
            sortOrder: "asc",
            renderCell: (params) => {
                return (
                    <div className="userListUser">
                        {params.row.first_name} {params.row.last_name}
                    </div>
                );
            },
        },
        {
            field: "phone_number",
            align: "left",
            headerName: "Phone Number",
            minWidth: 150,
            flex: 1,
            // width: 150,
        },
        // {
        //     field: "house_number",
        //     headerName: "Unit",
        //     // width: 100,
        //     minWidth: 100,
        //     flex: 1,
        //     align: "left",
        //     headerAlign: "left",
        // },

        {
            field: "NOTICE_DURATION",
            headerName: "Notice Duration",
            minWidth: 100,
            flex: 1,
            // width: 180,
            headerAlign: "left",
            renderCell: (params) => {
                return (
                    <>

                        <Switch
                            // checked={params.row.NOTICE_DURATION}
                            checked={Boolean(params.row.NOTICE_DURATION.toString().toLowerCase() === 'true')}
                            onChange={() => {
                            }}
                            inputProps={{'aria-label': 'controlled'}}
                        />
                    </>
                );
            },
        },
        {
            field: "MINIMUM_STAY",
            headerName: "Minimum Stay",
            minWidth: 100,
            flex: 1,
            // width: 180,
            headerAlign: "left",
            renderCell: (params) => {
                return (
                    <>
                        <Switch

                            checked={Boolean(params.row.MINIMUM_STAY.toString().toLowerCase() === 'true')}
                            onChange={() => {
                            }}
                            inputProps={{'aria-label': 'controlled'}}
                        />
                    </>
                );
            },
        },
        {
            field: "LANDLORD_NOTICE",
            headerName: "Landlord Notice",
            minWidth: 100,
            flex: 1,
            // width: 180,
            headerAlign: "left",
            renderCell: (params) => {
                return (
                    <>
                        <Switch
                            checked={Boolean(params.row.LANDLORD_NOTICE.toString().toLowerCase() === 'true')}
                            onChange={() => {
                            }}
                            inputProps={{'aria-label': 'controlled'}}
                        />
                    </>
                );
            },
        },
        {
            field: "date_removed",
            headerName: "Date Vacated",
            // width: 250,
            minWidth: 250,
            flex: 1,
            align: "left",
            headerAlign: "left",
        },
        {
            field: "action",
            headerName: "Actions",
            minWidth: 120,
            flex: 1,
            // width: 180,
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <>
                        {params.row.agency_id !== 0 &&
                        params.row.agency_id !== JSON.parse(originalText)[0][1] ? (
                            <></>
                        ) : (
                            <div className="userListAction">
                                <Button
                                    onClick={() => {
                                        navigate("/tenant/" + params.row.tenant_id, {
                                            state: {
                                                tenant_id: params.row.tenant_id,
                                                property_id: params.row.property_id,
                                            },
                                        });
                                    }}
                                    variant="outlined"
                                >
                                    Details
                                </Button>
                            </div>
                        )}
                    </>
                );
            },
        },
    ];

    const [age, setAge] = React.useState("");

    const handleChange = (event) => {
        setAge(event.target.value);
    };

    return (
        <>
            {backDrop}
            {/*DELETE MODAL*/}
            <Dialog
                open={deleteModal}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle style={{color: "red"}}>
                    Delete {tenantInfo.name}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <Typography>
                            Deleting a Tenant will completely remove them and their respective
                            documents from the system and render a house vacant.
                        </Typography>
                        <br/>
                        <Typography>
                            Are you sure you want to delete this tenant ?
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>
                        <span style={{color: "red"}}>Disagree</span>
                    </Button>
                    <LoadingButton
                        size="small"
                        onClick={handleDelete}
                        loading={loading}
                        startIcon={<SendIcon/>}
                        style={{color: "green"}}
                        loadingPosition="start"
                    >
                        Agree
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            {/*Arrears MODAL*/}
            <Dialog
                open={arrearsModal}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>
                    <div
                        style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        Add Arrear
                    </div>
                </DialogTitle>
                <DialogContent
                    style={{
                        padding: "10px",
                    }}
                >
                    <Formik initialValues={initialValues} onSubmit={addArrears}>
                        {(props) => (
                            <Form noValidate>
                                <Field
                                    as={TextField}
                                    name="first_name"
                                    label="Tenant Name"
                                    value={tenantInfo.name + " " + tenantInfo.last_name}
                                    variant="outlined"
                                    fullwidth
                                    required
                                    disabled={true}
                                    style={{marginTop: "8px", width: "100%"}}
                                />
                                <Field
                                    as={TextField}
                                    name="amount"
                                    label="Amount"
                                    type="number"
                                    fullwidth
                                    required
                                    variant="outlined"
                                    style={{
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        width: "100%",
                                    }}
                                />
                                <Field
                                    as={TextareaAutosize}
                                    name="description"
                                    required
                                    aria-label="minimum height"
                                    minRows={3}
                                    placeholder="Arrear description ... "
                                    style={{width: "100%"}}
                                />
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "end",
                                        marginTop: "20px",
                                    }}
                                >
                                    <Button onClick={handleClose}>
                                        <span style={{color: "red"}}>Cancel</span>
                                    </Button>
                                    <Button type="submit">
                                        <span style={{color: "green"}}>Submit</span>
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>

            {/*Add Tenant MODAL*/}
            <Dialog
                maxWidth={"md"}
                open={addTenantModal}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle
                    style={{
                        width: "90%",
                    }}
                >
                    <div
                        style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        Add Tenant
                    </div>
                </DialogTitle>
                <DialogContent
                    style={{
                        padding: "10px",
                    }}
                >
                    <Formik
                        initialValues={initialValues2}
                        // validationSchema={validationSchema}
                        onSubmit={addTenant}
                    >
                        {(props) => (
                            <Form noValidate>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Field
                                        as={TextField}
                                        name="first_name"
                                        label="First Name"
                                        variant="outlined"
                                        error={props.errors.first_name && props.touched.first_name}
                                        helperText={<ErrorMessage name="first_name"/>}
                                        required
                                        style={{marginTop: "10px", width: "49%"}}
                                    />
                                    <Field
                                        as={TextField}
                                        name="last_name"
                                        label="Last Name"
                                        error={props.errors.last_name && props.touched.last_name}
                                        helperText={<ErrorMessage name="last_name"/>}
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "49%"}}
                                    />
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Field
                                        as={TextField}
                                        name="email_address"
                                        label="Email"
                                        error={props.errors.email && props.touched.email}
                                        helperText={<ErrorMessage name="email"/>}
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "32%"}}
                                    />
                                    <Field
                                        as={TextField}
                                        name="phone_number"
                                        label="Phone Number"
                                        error={
                                            props.errors.phoneNumber && props.touched.phoneNumber
                                        }
                                        helperText={<ErrorMessage name="phoneNumber"/>}
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "32%"}}
                                    />
                                    <Field
                                        as={TextField}
                                        name="national_id"
                                        label="National ID"
                                        type="number"
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "32%"}}
                                    />
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <FormControl
                                        required
                                        style={{
                                            marginTop: "10px",
                                            width: "49%",
                                        }}
                                        label="Property *"
                                        name="is_student"
                                    >
                                        <InputLabel id="demo-simple-select-required-label">
                                            Student
                                        </InputLabel>
                                        <Select
                                            name="is_student"
                                            labelId="demo-simple-select-required-label"
                                            id="demo-simple-select-required"
                                            value={isStudent}
                                            label="Property *"
                                            onChange={(e) => {
                                                setIsStudent(e.target.value);
                                            }}
                                        >
                                            <MenuItem value="YES">
                                                <em>YES</em>
                                            </MenuItem>
                                            <MenuItem value="NO">
                                                <em>NO</em>
                                            </MenuItem>
                                        </Select>
                                        <FormHelperText>Required</FormHelperText>
                                    </FormControl>
                                    {isStudent === "YES" ? (
                                        <>
                                            <Field
                                                as={TextField}
                                                name="institution_name"
                                                label="Institution Name"
                                                variant="outlined"
                                                error={
                                                    props.errors.first_name && props.touched.first_name
                                                }
                                                helperText={<ErrorMessage name="first_name"/>}
                                                required
                                                style={{marginTop: "10px", width: "49%"}}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <Field
                                                as={TextField}
                                                name="institution_name"
                                                label="Institution Name"
                                                variant="outlined"
                                                disabled={true}
                                                error={
                                                    props.errors.first_name && props.touched.first_name
                                                }
                                                helperText={<ErrorMessage name="first_name"/>}
                                                required
                                                style={{marginTop: "10px", width: "49%"}}
                                            />
                                        </>
                                    )}
                                    <br/>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Field
                                        as={TextField}
                                        name="occupation_or_profession"
                                        label="Occupation"
                                        variant="outlined"
                                        error={props.errors.first_name && props.touched.first_name}
                                        helperText={<ErrorMessage name="first_name"/>}
                                        required
                                        style={{marginTop: "10px", width: "49%"}}
                                    />
                                    <Field
                                        as={TextField}
                                        name="place_of_work"
                                        label="Place Of Work"
                                        error={props.errors.last_name && props.touched.last_name}
                                        helperText={<ErrorMessage name="last_name"/>}
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "49%"}}
                                    />
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Field
                                        as={TextField}
                                        name="reason_for_relocating"
                                        label="Reason For Relocation"
                                        variant="outlined"
                                        error={props.errors.first_name && props.touched.first_name}
                                        helperText={<ErrorMessage name="first_name"/>}
                                        required
                                        style={{marginTop: "10px", width: "49%"}}
                                    />
                                    <Field
                                        as={TextField}
                                        name="previous_residence"
                                        label="Previous Residence"
                                        error={props.errors.last_name && props.touched.last_name}
                                        helperText={<ErrorMessage name="last_name"/>}
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "49%"}}
                                    />
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <FormControl
                                        name="property_name"
                                        required
                                        style={{
                                            marginTop: "10px",
                                            width: "32%",
                                        }}
                                        label="Property *"
                                    >
                                        <InputLabel id="demo-simple-select-required-label">
                                            Select Property
                                        </InputLabel>
                                        <Select
                                            name="property_name"
                                            labelId="demo-simple-select-required-label"
                                            id="demo-simple-select-required"
                                            value={addTenantPropertyName}
                                            label="Property *"
                                            onChange={(e) => {
                                                setAddTenantPropertyName(e.target.value);
                                                propertyID = e.target.value;
                                                setPropertyID(e.target.value);
                                                getUnits();
                                            }}
                                        >
                                            <MenuItem value={null}>
                                                <em>None</em>
                                            </MenuItem>
                                            {new Map(JSON.parse(originalText2))
                                                .get("properties")
                                                .map((property, index) => (
                                                    <MenuItem key={index} value={property.id}>
                                                        {property.property_name}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                        <FormHelperText>Required</FormHelperText>
                                    </FormControl>
                                    <br/>

                                    {units !== null ? (
                                        <>
                                            <FormControl
                                                name="house_number"
                                                size="small"
                                                required
                                                style={{
                                                    marginTop: "10px",
                                                    width: "32%",
                                                }}
                                                label="Property *"
                                            >
                                                <InputLabel id="demo-simple-select-required-label">
                                                    Select House NO
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-required-label"
                                                    id="demo-simple-select-required"
                                                    value={selectedUnit}
                                                    label="Unit *"
                                                    onChange={(e) => {
                                                        setSelectedUnit(e.target.value);
                                                    }}
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {units.map((unit, index) => {
                                                        let hse = unit.state;
                                                        if (hse === "OCCUPIED") {
                                                            return (
                                                                <MenuItem
                                                                    key={index}
                                                                    value={unit.unit}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                    }}
                                                                    disabled={true}
                                                                >
                                                                    <span>{unit.unit}</span>
                                                                    <small>{unit.state.toLowerCase()}</small>
                                                                </MenuItem>
                                                            );
                                                        } else {
                                                            return (
                                                                <MenuItem
                                                                    key={index}
                                                                    value={unit.unit}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                    }}
                                                                >
                                                                    <span>{unit.unit}</span>
                                                                    <small>{unit.state.toLowerCase()}</small>
                                                                </MenuItem>
                                                            );
                                                        }
                                                    })}
                                                </Select>
                                                <FormHelperText>Required</FormHelperText>
                                            </FormControl>
                                            <br/>
                                        </>
                                    ) : (
                                        <>
                                            <FormControl
                                                required
                                                style={{
                                                    marginTop: "10px",
                                                    width: "32%",
                                                }}
                                                disabled={true}
                                            >
                                                <InputLabel id="demo-simple-select-required-label">
                                                    Select House NO
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-required-label"
                                                    id="demo-simple-select-required"
                                                    value={"Select A Property To Select House NO ... "}
                                                ></Select>
                                            </FormControl>
                                            <br/>
                                        </>
                                    )}

                                    <Field
                                        as={TextField}
                                        name="rent"
                                        label="Rent"
                                        type="number"
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "32%"}}
                                    />
                                </div>

                                <br/>
                                <Typography style={{textAlign: "center"}}>
                                    NEXT OF KIN DETAILS
                                </Typography>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Field
                                        as={TextField}
                                        name="next_of_kin_first_name"
                                        label="First Name"
                                        error={props.errors.first_name && props.touched.first_name}
                                        helperText={<ErrorMessage name="first_name"/>}
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "32%"}}
                                    />
                                    <Field
                                        as={TextField}
                                        name="next_of_kin_last_name"
                                        label="Last Name"
                                        error={props.errors.first_name && props.touched.first_name}
                                        helperText={<ErrorMessage name="first_name"/>}
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "32%"}}
                                    />
                                    <Field
                                        as={TextField}
                                        name="next_of_kin_relationship"
                                        label="Relationship"
                                        error={props.errors.first_name && props.touched.first_name}
                                        helperText={<ErrorMessage name="first_name"/>}
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "32%"}}
                                    />
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Field
                                        as={TextField}
                                        name="next_of_kin_contacts"
                                        label="Phone Number"
                                        error={
                                            props.errors.phoneNumber && props.touched.phoneNumber
                                        }
                                        helperText={<ErrorMessage name="phoneNumber"/>}
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "49%"}}
                                    />
                                    <Field
                                        as={TextField}
                                        name="next_of_kin_national_id"
                                        label="National ID"
                                        type="number"
                                        required
                                        variant="outlined"
                                        style={{marginTop: "10px", width: "49%"}}
                                    />
                                </div>

                                <br/>
                                <Typography style={{textAlign: "center"}}>
                                    TENANT FILES
                                </Typography>
                                <br/>
                                <div
                                    style={{display: "flex", justifyContent: "space-between"}}
                                >
                  <span
                      style={{
                          width: "49%",
                          display: "flex",
                          justifyContent: "space-between",
                      }}
                  >
                    {tenantPhoto === null ? (
                        <>
                            <span>Tenant Photo </span>
                            <Button variant="outlined" component="label">
                                Upload File
                                <input
                                    type="file"
                                    onChange={(e) => handleFile1(e)}
                                    hidden
                                />
                            </Button>
                        </>
                    ) : (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                }}
                            >
                                <span>{photo}</span>
                                <DeleteOutline
                                    className="userListDelete"
                                    onClick={() => {
                                        setTenantPhoto(null);
                                        setPhoto(null);
                                    }}
                                />
                            </div>
                        </>
                    )}
                  </span>
                                    <span
                                        style={{
                                            width: "49%",
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                    {photoOfNationalID === null ? (
                        <>
                            <span>Photo Of National ID </span>
                            <Button variant="outlined" component="label">
                                Upload File
                                <input
                                    type="file"
                                    onChange={(e) => handleFile2(e)}
                                    hidden
                                />
                            </Button>
                        </>
                    ) : (
                        <>
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                    }}
                                >
                                    <span>{nationalID}</span>
                                    <DeleteOutline
                                        className="userListDelete"
                                        onClick={() => {
                                            setPhotoOfNationalID(null);
                                            setNationalID(null);
                                        }}
                                    />
                                </div>
                            </>
                        </>
                    )}
                  </span>
                                </div>
                                <br/>
                                <div
                                    style={{display: "flex", justifyContent: "space-between"}}
                                >
                  <span
                      style={{
                          width: "49%",
                          display: "flex",
                          justifyContent: "space-between",
                      }}
                  >
                    {copyOfContract === null ? (
                        <>
                            {" "}
                            <span>Copy Of Contract</span>
                            <Button variant="outlined" component="label">
                                Upload File
                                <input
                                    type="file"
                                    onChange={(e) => handleFile3(e)}
                                    hidden
                                />
                            </Button>
                        </>
                    ) : (
                        <>
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                    }}
                                >
                                    <span>{contract}</span>
                                    <DeleteOutline
                                        className="userListDelete"
                                        onClick={() => {
                                            setCopyOfContract(null);
                                            setContract(null);
                                        }}
                                    />
                                </div>
                            </>
                        </>
                    )}
                  </span>
                                    <span
                                        style={{
                                            width: "49%",
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                    {inventoryChecklist === null ? (
                        <>
                            <span>Inventory Checklist</span>
                            <Button variant="outlined" component="label">
                                Upload File
                                <input
                                    type="file"
                                    onChange={(e) => handleFile4(e)}
                                    hidden
                                />
                            </Button>
                        </>
                    ) : (
                        <>
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                    }}
                                >
                                    <span>{checklist}</span>
                                    <DeleteOutline
                                        className="userListDelete"
                                        onClick={() => {
                                            setInventoryChecklist(null);
                                            setChecklist(null);
                                        }}
                                    />
                                </div>
                            </>
                        </>
                    )}
                  </span>
                                </div>

                                <br/>
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "end",
                                        marginTop: "20px",
                                    }}
                                >
                                    <Button onClick={handleClose}>
                                        <span style={{color: "red"}}>Cancel</span>
                                    </Button>
                                    <LoadingButton
                                        size="small"
                                        type="submit"
                                        loading={loading}
                                        startIcon={<SendIcon/>}
                                        style={{color: "green"}}
                                        loadingPosition="start"
                                    >
                                        Submit
                                    </LoadingButton>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>

            <div className="userList">
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    {matches ? (
                        <></>
                    ) : (
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={new Map(JSON.parse(originalText2))
                                .get("properties")
                                .map((property, index) => {
                                    return property.property_name;
                                })}
                            style={{width: 300, padding: "10px 10px"}}
                            onChange={(e, value) => {
                                let propertySelected = new Map(JSON.parse(originalText2))
                                    .get("properties")
                                    .filter(
                                        (property, index) => property.property_name === value
                                    );
                                let selectedPropertyId = new Map(
                                    Object.entries(
                                        new Map(Object.entries(propertySelected)).get("0")
                                    )
                                ).get("id");

                                searchProperty(selectedPropertyId);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    id="outlined-basic"
                                    label="Filter Properties ... "
                                    variant="outlined"
                                    name="property"
                                    {...params}
                                />
                            )}
                        />
                    )}

                    <div
                        style={{
                            padding: "10px 10px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <TextField
                            id="outlined-basic"
                            label="Search old tenants ... "
                            variant="outlined"
                            name="firstname"
                            onChange={(e) => {
                                searchUser(e);
                            }}
                            style={{paddingRight: "10px"}}
                        />
                    </div>
                    {/*<Button*/}
                    {/*  onClick={(e) => {*/}
                    {/*    setAddTenantModal(true);*/}
                    {/*  }}*/}
                    {/*  variant="outlined"*/}
                    {/*  style={{*/}
                    {/*    color: "white",*/}
                    {/*    text_transform: "uppercase",*/}
                    {/*    width: "200px",*/}
                    {/*    line_height: "50px",*/}
                    {/*    border_radius: "5px",*/}
                    {/*    background: "#00B000",*/}
                    {/*    text_align: "center",*/}
                    {/*    box_shadow: "inset 0 0 25px rgba(0,0,0,.25)",*/}
                    {/*    marginRight: "10px",*/}
                    {/*  }}*/}
                    {/*>*/}
                    {/*  Add Tenant*/}
                    {/*</Button>*/}
                </div>
                <div className={"userListDataGrid"}>
                    <DataGrid
                        initialState={{
                            sorting: {
                                sortModel: [{field: "date_removed", sort: "desc"}],
                            },
                        }}
                        className={classes.root}
                        rows={searchResults}
                        disableSelectionOnClick
                        rowHeight={45}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                    />
                </div>
            </div>
        </>
    );
}
